<template>
    <div class="bc__ui__donut__progress">
        <svg height="100%" width="100%" viewBox="0 0 100 100" class="donut__chart">
            <circle cx="50" cy="50" r="50" class="stroke--base" stroke-width="6" fill="transparent"  />
            <circle cx="50" cy="50" r="50" class="stroke--curr" stroke-width="6" :stroke-dasharray="myDashArray(val)" fill="transparent" />
        </svg>
    </div>
</template>

<style lang="scss" scoped >

</style>


<script>
    export default {

        props: [
            'radius', 'val', 'max'
        ],

        components: {
            
        },

        methods: {
/*                 {% set arrayIni = ((2 * 3.141592654 * radius) / 4) * 2.5 %}
                {% set arrayFin = ((2 * 3.141592654 * radius) - arrayIni) %}
                
                {% set currentIni = arrayIni * location.value / topLimit %}
                {% set currentFin = ((2 * 3.141592654 * radius) - currentIni) %} */
            myDashArray(val) {
                const myproportion = this.val / this.max;
                const circunference = 2 * Math.PI * 50;
                return [ circunference * myproportion, (1 - myproportion) * circunference ];
            },

            myDashOffset(val, index) {

            },
        }
    }

</script>